// extracted by mini-css-extract-plugin
module.exports = {"category":"PageHeader_category_1KC1u","title":"PageHeader_title_t099B"};